/** Explicitly reviewed secondary-school pairs. See schoolSubjectEvidence.ts for
 * sources and exclusions. Kept compact because route resolution runs in the shell;
 * never import the full school catalogue or evidence there.
 * Tuple: [school slug, English pathways, Chemistry pathways]. Empty = unpublished.
 */
export type EnglishSchoolPathway = 'national' | 'g1' | 'ip' | 'ib-school';
export type ChemistrySchoolPathway = 'pure' | 'combined' | 'ip';
export const SCHOOL_SUBJECT_ELIGIBILITY: readonly (readonly [
  slug: string,
  english: readonly EnglishSchoolPathway[],
  chemistry: readonly ChemistrySchoolPathway[],
])[] = [
  ['admiralty-secondary-school', ['national'], ['pure', 'combined']],
  ['ahmad-ibrahim-secondary-school', ['national'], ['pure', 'combined']],
  ['anderson-secondary-school', ['national'], ['pure', 'combined']],
  ['ang-mo-kio-secondary-school', ['national'], ['pure', 'combined']],
  ['anglican-high-school', ['national'], ['pure']],
  ['anglo-chinese-school-barker-road', ['national'], ['pure', 'combined']],
  [
    'anglo-chinese-school-independent',
    ['national', 'ib-school'],
    ['pure', 'ip'],
  ],
  ['assumption-english-school', ['national'], ['pure', 'combined']],
  ['assumption-pathway-school', [], []],
  ['bartley-secondary-school', ['national'], ['pure', 'combined']],
  ['beatty-secondary-school', ['national'], ['pure', 'combined']],
  ['bedok-green-secondary-school', ['national'], ['pure', 'combined']],
  ['bedok-south-secondary-school', ['national'], ['pure', 'combined']],
  ['bedok-view-secondary-school', ['national'], ['pure', 'combined']],
  ['bendemeer-secondary-school', ['national'], ['pure', 'combined']],
  ['boon-lay-secondary-school', ['national'], ['pure', 'combined']],
  ['bowen-secondary-school', ['national'], ['pure', 'combined']],
  ['broadrick-secondary-school', ['national'], ['pure', 'combined']],
  ['bukit-batok-secondary-school', ['national'], ['pure', 'combined']],
  ['bukit-merah-secondary-school', ['national'], ['pure', 'combined']],
  ['bukit-panjang-govt-high-school', ['national'], ['pure', 'combined']],
  ['bukit-view-secondary-school', ['national'], ['pure', 'combined']],
  ['canberra-secondary-school', ['national'], ['pure', 'combined']],
  ['catholic-high-school', ['national', 'ip'], ['pure', 'ip']],
  [
    'cedar-girls-secondary-school',
    ['national', 'ip'],
    ['pure', 'combined', 'ip'],
  ],
  ['changkat-changi-secondary-school', ['national'], ['pure', 'combined']],
  ['chij-katong-convent', ['national'], ['pure', 'combined']],
  ['chij-secondary-toa-payoh', ['national'], ['pure', 'combined']],
  ['chij-st-josephs-convent', ['national'], ['pure', 'combined']],
  ['chij-st-nicholas-girls-school', ['national', 'ip'], ['pure', 'ip']],
  ['chij-st-theresas-convent', ['national'], ['pure', 'combined']],
  ['christ-church-secondary-school', ['national'], ['pure', 'combined']],
  ['chua-chu-kang-secondary-school', ['national'], ['pure', 'combined']],
  ['chung-cheng-high-school-main', ['national'], ['pure', 'combined']],
  ['chung-cheng-high-school-yishun', ['national'], ['pure', 'combined']],
  ['clementi-town-secondary-school', ['national'], ['pure', 'combined']],
  ['commonwealth-secondary-school', ['national'], ['pure', 'combined']],
  ['compassvale-secondary-school', ['national'], ['pure', 'combined']],
  ['crescent-girls-school', ['national'], ['pure', 'combined']],
  ['crest-secondary-school', ['g1'], []],
  ['damai-secondary-school', ['national'], ['pure', 'combined']],
  ['deyi-secondary-school', ['national'], ['pure', 'combined']],
  ['dunearn-secondary-school', ['national'], ['pure', 'combined']],
  ['dunman-high-school', ['ip'], ['ip']],
  ['dunman-secondary-school', ['national'], ['pure', 'combined']],
  ['east-spring-secondary-school', ['national'], ['pure', 'combined']],
  ['edgefield-secondary-school', ['national'], ['pure', 'combined']],
  ['evergreen-secondary-school', ['national'], ['pure', 'combined']],
  ['fairfield-methodist-school-secondary', ['national'], ['pure', 'combined']],
  ['fuhua-secondary-school', ['national'], ['pure', 'combined']],
  ['gan-eng-seng-school', ['national'], ['pure', 'combined']],
  ['geylang-methodist-school-secondary', ['national'], ['pure', 'combined']],
  ['greendale-secondary-school', ['national'], ['pure', 'combined']],
  ['greenridge-secondary-school', ['national'], ['pure', 'combined']],
  ['guangyang-secondary-school', ['national'], ['pure', 'combined']],
  ['hai-sing-catholic-school', ['national'], ['pure', 'combined']],
  ['hillgrove-secondary-school', ['national'], ['pure', 'combined']],
  ['holy-innocents-high-school', ['national'], ['pure', 'combined']],
  ['hougang-secondary-school', ['national'], ['pure', 'combined']],
  ['hua-yi-secondary-school', ['national'], ['pure', 'combined']],
  ['hwa-chong-institution', ['ip'], ['ip']],
  ['junyuan-secondary-school', ['national'], ['pure', 'combined']],
  ['jurong-secondary-school', ['national'], ['pure', 'combined']],
  ['jurong-west-secondary-school', ['national'], ['pure', 'combined']],
  ['jurongville-secondary-school', ['national'], ['pure', 'combined']],
  ['juying-secondary-school', ['national'], ['pure', 'combined']],
  ['kent-ridge-secondary-school', ['national'], ['pure', 'combined']],
  ['kranji-secondary-school', ['national'], ['pure', 'combined']],
  [
    'kuo-chuan-presbyterian-secondary-school',
    ['national'],
    ['pure', 'combined'],
  ],
  ['loyang-view-secondary-school', ['national'], ['pure', 'combined']],
  ['manjusri-secondary-school', ['national'], ['pure', 'combined']],
  ['maris-stella-high-school', ['national'], ['pure', 'combined']],
  ['marsiling-secondary-school', ['national'], ['pure', 'combined']],
  ['mayflower-secondary-school', ['national'], ['pure', 'combined']],
  ['meridian-secondary-school', ['national'], ['pure', 'combined']],
  [
    'methodist-girls-school-secondary',
    ['national', 'ib-school'],
    ['pure', 'ip'],
  ],
  ['montfort-secondary-school', ['national'], ['pure', 'combined']],
  ['nan-chiau-high-school', ['national'], ['pure', 'combined']],
  ['nan-hua-high-school', ['national'], ['pure']],
  ['nanyang-girls-high-school', ['ip'], ['ip']],
  ['national-junior-college', ['ip'], ['ip']],
  ['naval-base-secondary-school', ['national'], ['pure', 'combined']],
  ['new-town-secondary-school', ['national'], ['pure', 'combined']],
  ['ngee-ann-secondary-school', ['national'], ['pure', 'combined']],
  ['north-vista-secondary-school', ['national'], ['pure', 'combined']],
  ['northbrooks-secondary-school', ['national'], ['pure', 'combined']],
  ['northland-secondary-school', ['national'], ['pure', 'combined']],
  ['northlight-school', [], []],
  ['nus-high-school-of-mathematics-and-science', ['ip'], ['ip']],
  ['orchid-park-secondary-school', ['national'], ['pure', 'combined']],
  ['outram-secondary-school', ['national'], ['pure', 'combined']],
  ['pasir-ris-crest-secondary-school', ['national'], ['pure', 'combined']],
  ['pasir-ris-secondary-school', ['national'], ['pure', 'combined']],
  [
    'paya-lebar-methodist-girls-school-secondary',
    ['national'],
    ['pure', 'combined'],
  ],
  ['pei-hwa-secondary-school', ['national'], ['pure', 'combined']],
  ['peicai-secondary-school', ['national'], ['pure', 'combined']],
  ['peirce-secondary-school', ['national'], ['pure', 'combined']],
  ['presbyterian-high-school', ['national'], ['pure', 'combined']],
  ['punggol-secondary-school', ['national'], ['pure', 'combined']],
  ['queenstown-secondary-school', ['national'], ['pure', 'combined']],
  ['queensway-secondary-school', ['national'], ['pure', 'combined']],
  ['raffles-girls-school-secondary', ['ip'], ['ip']],
  ['raffles-institution', ['ip'], ['ip']],
  ['regent-secondary-school', ['national'], ['pure', 'combined']],
  ['river-valley-high-school', ['ip'], ['ip']],
  ['riverside-secondary-school', ['national'], ['pure', 'combined']],
  ['school-of-science-and-technology-singapore', ['national'], ['pure']],
  ['school-of-the-arts-singapore', ['ib-school'], []],
  ['sembawang-secondary-school', ['national'], ['pure', 'combined']],
  ['seng-kang-secondary-school', ['national'], ['pure', 'combined']],
  ['serangoon-garden-secondary-school', ['national'], ['pure', 'combined']],
  ['serangoon-secondary-school', ['national'], ['pure', 'combined']],
  [
    'singapore-chinese-girls-school',
    ['national', 'ip'],
    ['pure', 'combined', 'ip'],
  ],
  ['singapore-sports-school', ['national'], ['pure', 'combined']],
  ['spectra-secondary-school', ['g1'], []],
  ['springfield-secondary-school', ['national'], ['pure', 'combined']],
  ['st-andrews-school-secondary', ['national'], ['pure', 'combined']],
  [
    'st-anthonys-canossian-secondary-school',
    ['national'],
    ['pure', 'combined'],
  ],
  ['st-gabriels-secondary-school', ['national'], ['pure', 'combined']],
  ['st-hildas-secondary-school', ['national'], ['pure', 'combined']],
  ['st-josephs-institution', ['national', 'ib-school'], ['pure', 'ip']],
  ['st-margarets-school-secondary', ['national'], ['pure', 'combined']],
  ['unity-secondary-school', ['national'], ['pure', 'combined']],
  ['st-patricks-school', ['national'], ['pure', 'combined']],
  ['swiss-cottage-secondary-school', ['national'], ['pure', 'combined']],
  ['tampines-secondary-school', ['national'], ['pure', 'combined']],
  ['tanjong-katong-girls-school', ['national'], ['pure', 'combined']],
  ['tanjong-katong-secondary-school', ['national'], ['pure', 'combined']],
  ['temasek-junior-college', ['ip'], ['ip']],
  ['temasek-secondary-school', ['national'], ['pure', 'combined']],
  ['victoria-school', ['national', 'ip'], ['pure', 'combined', 'ip']],
  ['west-spring-secondary-school', ['national'], ['pure', 'combined']],
  ['westwood-secondary-school', ['national'], ['pure', 'combined']],
  ['whitley-secondary-school', ['national'], ['pure', 'combined']],
  ['woodgrove-secondary-school', ['national'], ['pure', 'combined']],
  ['woodlands-ring-secondary-school', ['national'], ['pure', 'combined']],
  ['woodlands-secondary-school', ['national'], ['pure', 'combined']],
  ['xinmin-secondary-school', ['national'], ['pure', 'combined']],
  ['yio-chu-kang-secondary-school', ['national'], ['pure', 'combined']],
  ['yishun-secondary-school', ['national'], ['pure', 'combined']],
  ['yishun-town-secondary-school', ['national'], ['pure', 'combined']],
  ['yuan-ching-secondary-school', ['national'], ['pure', 'combined']],
  ['yuhua-secondary-school', ['national'], ['pure', 'combined']],
  ['yusof-ishak-secondary-school', ['national'], ['pure', 'combined']],
  ['yuying-secondary-school', ['national'], ['pure', 'combined']],
  ['zhenghua-secondary-school', ['national'], ['pure', 'combined']],
  ['zhonghua-secondary-school', ['national'], ['pure', 'combined']],
  ['anglo-chinese-school-international', [], []],
  ['australian-international-school', [], []],
  ['canadian-international-school-lakeside', [], []],
  ['chatsworth-international-school', [], []],
  ['dover-court-international-school', [], []],
  ['dulwich-college-singapore', [], []],
  ['german-european-school-singapore', [], []],
  ['global-indian-international-school', [], []],
  ['hwa-international-school', [], []],
  ['hwa-chong-international-school', ['ib-school'], []],
  ['iss-international-school', [], []],
  ['nexus-international-school', [], []],
  ['north-london-collegiate-school-singapore', [], []],
  ['nps-international-school', [], []],
  ['one-world-international-school-nanyang', [], []],
  ['overseas-family-school', [], []],
  ['sji-international', [], []],
  ['stamford-american-international-school', [], []],
  ['tanglin-trust-school', [], []],
  ['uwcsea-dover', [], []],
  ['uwcsea-east', [], []],
  ['westbourne-college-singapore', [], []],
  ['xcl-world-academy', [], []],
];
